/** AUTO GENERATED FROM "node ./src/utils/convert-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg width="66.15" height="95.58" viewBox="0 0 66.15 95.58" fill="currentColor" className={classNames('nmx-icon', className)} ref={svgRef} {...otherProps}>
        <defs>
          <mask id="b238f287-dc18-4f6e-bba2-6d9aebf4df4d" x="0" y="0" width="66.15" height="95.58" maskUnits="userSpaceOnUse">
            <g transform="translate(-44 -29)">
              <polygon points="44 124.58 110.15 124.58 110.15 29 44 29 44 124.58" fill="#fff" fillRule="evenodd"/>
            </g>
          </mask>
        </defs>
        <g>
          <path d="M52.27,117.13c0-13.67,11.13-22.89,24.8-22.89s24.8,9.22,24.8,22.89" transform="translate(-44 -29)" fill="#ffb81c" fillRule="evenodd"/>
          <path d="M96,68.59A93.58,93.58,0,0,0,77.07,66.8,93.55,93.55,0,0,0,58.2,68.59h0a25.29,25.29,0,0,0,37.75,0Z" transform="translate(-44 -29)" fill="#ffb81c" fillRule="evenodd"/>
          <g mask="url(#b238f287-dc18-4f6e-bba2-6d9aebf4df4d)">
            <path d="M108.9,29H45.25A1.25,1.25,0,0,0,44,30.25v6.2a1.25,1.25,0,0,0,1.25,1.25H108.9a1.25,1.25,0,0,0,1.25-1.25v-6.2A1.25,1.25,0,0,0,108.9,29Zm-1.25,2.5v3.7H46.5V31.5Z" transform="translate(-44 -29)" fill="#0e497b"/>
          </g>
          <g mask="url(#b238f287-dc18-4f6e-bba2-6d9aebf4df4d)">
            <path d="M52.27,35.2a1.26,1.26,0,0,1,1.25,1.12V52.83a22.94,22.94,0,0,0,20,22.72A1.25,1.25,0,0,1,73.24,78,25.43,25.43,0,0,1,51,53.22V36.45A1.24,1.24,0,0,1,52.27,35.2Z" transform="translate(-44 -29)" fill="#0e497b"/>
          </g>
          <g mask="url(#b238f287-dc18-4f6e-bba2-6d9aebf4df4d)">
            <path d="M101.87,35.7a1.26,1.26,0,0,1,1.25,1.12v16A25.43,25.43,0,0,1,80.9,78a1.25,1.25,0,0,1-.31-2.48,22.93,22.93,0,0,0,20-22.35V37A1.25,1.25,0,0,1,101.87,35.7Z" transform="translate(-44 -29)" fill="#0e497b"/>
          </g>
          <g mask="url(#b238f287-dc18-4f6e-bba2-6d9aebf4df4d)">
            <path d="M108.9,115.88H45.25A1.25,1.25,0,0,0,44,117.13v6.2a1.25,1.25,0,0,0,1.25,1.25H108.9a1.25,1.25,0,0,0,1.25-1.25v-6.2A1.25,1.25,0,0,0,108.9,115.88Zm-1.25,2.5v3.7H46.5v-3.7Z" transform="translate(-44 -29)" fill="#0e497b"/>
          </g>
          <g mask="url(#b238f287-dc18-4f6e-bba2-6d9aebf4df4d)">
            <path d="M73.24,75.55a1.26,1.26,0,0,1,1.4,1.09A1.24,1.24,0,0,1,73.56,78a22.93,22.93,0,0,0-20,22.35v16.75a1.25,1.25,0,0,1-2.49.13V100.75A25.44,25.44,0,0,1,73.24,75.55Z" transform="translate(-44 -29)" fill="#0e497b"/>
          </g>
          <g mask="url(#b238f287-dc18-4f6e-bba2-6d9aebf4df4d)">
            <path d="M80.9,75.55a25.44,25.44,0,0,1,22.22,24.82v16.76a1.25,1.25,0,0,1-2.49.13V100.75A22.94,22.94,0,0,0,80.59,78a1.25,1.25,0,0,1,.19-2.49Z" transform="translate(-44 -29)" fill="#0e497b"/>
          </g>
          <g mask="url(#b238f287-dc18-4f6e-bba2-6d9aebf4df4d)">
            <path d="M78.48,79.85a1.41,1.41,0,1,1-1.41-1.41,1.41,1.41,0,0,1,1.41,1.41" transform="translate(-44 -29)" fill="#ffb81c" fillRule="evenodd"/>
          </g>
          <g mask="url(#b238f287-dc18-4f6e-bba2-6d9aebf4df4d)">
            <path d="M78.48,84.9a1.41,1.41,0,1,1-1.41-1.41,1.41,1.41,0,0,1,1.41,1.41" transform="translate(-44 -29)" fill="#ffb81c" fillRule="evenodd"/>
          </g>
          <g mask="url(#b238f287-dc18-4f6e-bba2-6d9aebf4df4d)">
            <path d="M78.48,90a1.41,1.41,0,1,1-1.41-1.41A1.41,1.41,0,0,1,78.48,90" transform="translate(-44 -29)" fill="#ffb81c" fillRule="evenodd"/>
          </g>
        </g>
      </svg>

    );
  }
}

Icon.displayName = 'HourglassIcon';

export default Icon;
